<template>
    <v-dialog
        v-model="dialogOpen"
        max-width="700"
        persistent
    >
        <v-sheet>
            <toolbar-page title="Batch action"
                          disable-icon>
                <template slot="buttons">
                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="closeDialog">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>
            </toolbar-page>

            <div v-if="actions.length === 0">
                <v-alert type="warning" icon="mdi-alert" class="ma-2 body-2">
                    You don't have sufficient privileges to perform any batch actions.
                </v-alert>
            </div>

            <div v-if="actions.length > 0">

                <v-alert prominent type="error" class="ma-3 body-2" v-if="showDeleteWarning">
                    WARNING: Do not delete panelists that have activity history as this can impact your reporting. Instead set panelist
                    unsubscribed and Sample Ninja will automatically remove them after one year.
                </v-alert>

                <v-alert prominent v-if="showChangeWarning" type="warning" icon="mdi-alert" class="ma-2 body-2">
                    This batch operation will affect {{ affectedCount.toLocaleString() }} panelists!
                </v-alert>

                <v-alert prominent v-if="showChangeWarning" type="error" class="body-2 ml-3 mr-3 mt-5 mb-0" icon="mdi-alert">
                    WARNING: Final confirmation. This batch operation will affect <b>{{ affectedCount.toLocaleString() }}</b>
                    panelists!
                </v-alert>

                <v-alert prominent v-if="showExportLimitWarning" type="error" class="body-2 ml-3 mr-3 mt-5 mb-0" icon="mdi-alert">
                    You cannot export more than 100k panelists at one time. Narrow your filter and try again.
                </v-alert>

                <v-alert prominent v-if="selectedAction.type === 'create-email'" type="info" class="body-2 ml-3 mr-3 mt-5 mb-0" icon="mdi-alert">
                    Sample Ninja will send "Create password email" for {{affectedCount.toLocaleString()}} the panelists.
                    The email template can be configured under each Sub Panel.
                </v-alert>

                <v-list v-if="!showWarningAndOptions" class="pt-0">

                    <v-subheader>Select batch action</v-subheader>

                    <template v-for="(action, index) in actions">

                        <v-list-item @click="batchActionSelected(action)" v-if="hasPermission(action.permission)">

                            <v-list-item-avatar>
                                <v-icon>
                                    {{ action.icon }}
                                </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                {{ action.name }}
                            </v-list-item-content>

                        </v-list-item>

                        <v-divider v-if="index < actions.length-1 && hasPermission(action.permission)"></v-divider>

                    </template>
                </v-list>

                <v-card v-if="showWarningAndOptions">
                    <v-card-text class="pt-4">

                        <div v-if="selectedAction.options">
                            {{ selectedAction.options.label }}
                        </div>

                        <v-select
                            v-if="selectedAction.options"
                            v-model="selectedModel"
                            :items="selectedAction.options.values"
                            label="Please select"
                            item-text="name"
                            item-value="value"
                            hide-details
                            return-object
                            solo
                            background-color="grey darken-2"
                        >
                        </v-select>
                    </v-card-text>

                    <v-card-actions class="text-right">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="selectedAction.options && !selectedModel || showExportLimitWarning"
                               @click="confirmClicked">
                            CONFIRM
                        </v-btn>
                        <v-btn text @click="closeDialog">ABORT</v-btn>
                    </v-card-actions>

                </v-card>
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';

export default {

    components: {
        ToolbarPage,
    },

    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        affectedCount: {
            type: Number | null,
            required: true,
        },
        actions: {
            type: Array,
            required: true,
            validator: actions => {
                // Validate actions structure
                let errorCount = 0;
                actions.forEach(action => {
                    if (!action.name || !action.type || !action.icon) errorCount++;
                    if (action.hasOwnProperty('options')) {
                        if (!action.options.hasOwnProperty('values') ||
                            !action.options.hasOwnProperty('label')) errorCount++;
                        if (!action.hasOwnProperty('selected')) errorCount++;
                    }
                });
                return errorCount === 0;
            }
        }
    },

    watch: {
        value() {
            // Reset component
            this.selectedModel = null;
            this.showWarningAndOptions = false;
        }
    },

    data() {
        return {
            dialog: false,
            confirmationModel: false,
            selectedModel: null,
            showWarningAndOptions: false,
            selectedAction: {},
        }
    },

    computed: {
        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },

        showChangeWarning() {
            return ['delete', 'subpanel', 'status'].includes(this.selectedAction.type);
        },

        showDeleteWarning() {
            return ['delete'].includes(this.selectedAction.type);
        },

        showExportLimitWarning() {
            return ['export'].includes(this.selectedAction.type) && this.affectedCount > 100000;
        }
    },

    methods: {

        batchActionSelected(action) {
            this.selectedAction = action;

            if (action.options) {
                this.selectedModel = action.options.values[0];
            }

            this.showWarningAndOptions = true;
        },
        confirmClicked() {
            const config = {
                type: this.selectedAction.type,
                selected: this.selectedModel
            };
            this.$emit('action', config);
            this.closeDialog();
        },
        closeDialog() {
            this.selectedAction = {};
            this.$emit('input', false);
        },
    }
}
</script>
